import { useState, useEffect } from 'react'

import { gql, useQuery } from '@apollo/client';
import { useMarket } from './market';
import { THREE_MINUTES } from './pollIntervals';



const BANKALGO_MKT_QUERY = gql`
query($envName: String) {
  connectionType(where: {marketId: {_eq: 1004}, environment: {name: {_eq: $envName}}}) {
    id
    typeId
    typeName
    environment {
      name
    }
    connections {
      companyAbbreviation
      companyName
      markets: connectionInfo(path: "boundMarkets")
    }
  }
}
`

export const useBankAlgo = () => {

    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(BANKALGO_MKT_QUERY, { pollInterval: THREE_MINUTES })

    useEffect(() => {
        if (!loading && data) {
            let lookupTemp = {}
            data.connectionType.forEach(ctype => {
                let envName = ctype.environment.name
                let typeId = ctype.typeId.toString()
                let typeName = ctype.typeName

                if (!lookupTemp[envName]) {
                    lookupTemp[envName] = {}
                }
                lookupTemp[envName][typeId] = typeName
            })
            setLookupData(lookupTemp)
        }
    }, [data, loading])

    return lookupData
}


export const useBankAlgoNameToCompany = (serviceGroupSelected, envName = "") => {
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(BANKALGO_MKT_QUERY, {
        variables: envName ? { envName: envName } : null,
        pollInterval: THREE_MINUTES,
        skip: serviceGroupSelected === "fixgworders" ? false : true
    })

    useEffect(() => {
        if (!loading && data) {
            let lookupTemp = {}
            data.connectionType.forEach(ctype => {
                let envName = ctype.environment.name
                let typeName = ctype.typeName
                let companies = {}
                ctype.connections.forEach(row => {
                    let companyAbbr = row.companyAbbreviation
                    let companyName = row.companyName
                    if (companyAbbr && !companies.hasOwnProperty[companyAbbr] && companyName !== "Trading Technologies") {
                        companies[companyAbbr] = companyName
                    }

                })

                if (!lookupTemp[envName]) {
                    lookupTemp[envName] = {}
                }
                lookupTemp[envName][typeName] = companies
            })
            setLookupData(lookupTemp)
        }
    }, [data, loading])
    return lookupData
}

export const useBankAlgoNameToMarkets = (serviceGroupSelected) => {
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(BANKALGO_MKT_QUERY,
        {
            pollInterval: THREE_MINUTES,
            skip: serviceGroupSelected === "fixgworders" ? false : true
        }
    )
    const marketLookup = useMarket()

    useEffect(() => {
        if (!loading && data && marketLookup) {
            let lookupTemp = {}
            data.connectionType.forEach(ctype => {
                let envName = ctype.environment.name
                let typeName = ctype.typeName
                let supportedMarkets = []
                ctype.connections.forEach(row => {
                    let marketsByConnection = row.markets ? row.markets.split("|") : []
                    marketsByConnection.forEach(marketId => {
                        let marketName = marketLookup[marketId] ? marketLookup[marketId].name : marketId
                        supportedMarkets.push(marketName)
                    })
                })

                if (!lookupTemp[envName]) {
                    lookupTemp[envName] = {}
                }
                lookupTemp[envName][typeName] = [...new Set(supportedMarkets)].sort()
            })
            setLookupData(lookupTemp)
        }
    }, [marketLookup, data, loading])
    return lookupData
}
